export const isValidPhone = (phone) => {
  const regex = /^([+]?\d{1,2}[-\s]?|)[9|8|6|7][0-9]{8}$/
  return regex.test(phone)
}
